module.exports = __webpack_public_path__ + "static/media/student-boy.b2f185ac.png";